import store from '@/store';
import tracking from '@/aspects/trackings';
import { paymentGatewayMap, payMethodNameMap, WISE } from '@/views/checkout/payment/helper/constant';
import { getApmGaTrackingName } from '@/views/checkout/payment/helper/util';
import { translation } from '@/plugins/i18n';

export const generateCheckoutTileList = (checkoutTileMap) => {
  const checkoutTileList = [
    {isActive: false, current: checkoutTileMap.signUp, next: checkoutTileMap.address},
    {isActive: false, current: checkoutTileMap.address, next: checkoutTileMap.payment},
    {isActive: false, current: checkoutTileMap.payment, next: ''},
  ];

  const checkoutTileListInr = [
    {isActive: false, current: checkoutTileMap.signUp, next: checkoutTileMap.address},
    {isActive: false, current: checkoutTileMap.address, next: checkoutTileMap.payment},
    {isActive: false, current: checkoutTileMap.payment, next: ''},
  ];

  const checkoutTileListZeZsForIndia = [
    {isActive: false, current: checkoutTileMap.signUp, next: checkoutTileMap.address},
    {isActive: false, current: checkoutTileMap.address, next: checkoutTileMap.useVerification},
    {isActive: false, current: checkoutTileMap.payment, next: ''},
    {isActive: false, current: checkoutTileMap.useVerification, next: checkoutTileMap.payment}
  ]
  return {
    checkoutTileList,
    checkoutTileListInr,
    checkoutTileListZeZsForIndia
  }
}

export const generateGAbizInfo = (isArr = true) => {
  try {
    const getters = store.getters;
    const { addressInfo , countryList } = getters;
    const { employeeCount,accountHq ,usageType} = addressInfo
    const country = countryList.find(country => country.value === accountHq)?.label || accountHq
    return isArr? [
      usageType,
      employeeCount,
      country
    ]:{
      'businessPersonalAccount':		usageType,
      'businessSize': employeeCount,
      'businessRegion': country,
    }
  } catch {
    return isArr? [] : {}
  }
}

export const generatePaymentMethodInfo = () => {
  const { apmInfo, paymentMethodInfo } = store.getters;
  const apmPaymentGateway = apmInfo.apmPaymentMethodName === WISE ? paymentGatewayMap.Wise : paymentGatewayMap.Stripe;
  const apmGaTrackingName = getApmGaTrackingName(apmInfo.apmPaymentMethodName, apmInfo.tileImageFileName);
  return {
    paymentType: apmInfo.isApm ? translation(payMethodNameMap[apmGaTrackingName]) : paymentMethodInfo.paymentType,
    paymentGateway: apmInfo.isApm ? apmPaymentGateway : paymentMethodInfo.paymentGateway || undefined,
  }
}

export const sendGAbizInfo = (buyInteraction, buySelection ) => {
    try{
      const getters = store.getters;
      const { persistState } = getters;
      const { accountBizInfo } = persistState
      const {
        businessPersonalAccount,
        businessSize,
        businessRegion
      } = accountBizInfo
      tracking.buyInteractionWithBizInfo(
        buyInteraction, buySelection,
        businessPersonalAccount,
        businessSize,
        businessRegion);
    } catch (e) {
      console.log(e);
    }
}

/**
 * get first scrollable parent of ele
 * @param {object} ele
 * @returns element
 */
export const getFirstScrollableParent = (ele) => {
  let targetEle = ele.parentElement;
  while (targetEle) {
    const style = window.getComputedStyle(targetEle);
    const overflowRegex = /(auto|scroll)/;
    if (
      overflowRegex.test(`${style.overflow};${style.overflowY}`) &&
      targetEle.scrollHeight > targetEle.clientHeight
    ) {
      return targetEle;
    }
    targetEle = targetEle.parentElement;
  }
  return document.documentElement;
};

/**
 * get scroll top offset of scrollable parent
 */
export const getCheckoutScrollPaddingTop = () => {
  const defaultPaddingTop = 100;
  const opcHead = document.querySelector('#new_buyflow_header_container');
  const opcDrawer = document.querySelector('#the-main-content .opc-layout__layer__inner');
  const topOffset = [opcHead, opcDrawer].filter(Boolean).reduce((acc, item) => {
    return acc + item.offsetHeight;
  }, defaultPaddingTop);
  return topOffset;
}

/**
 * scroll to the top of view
 * @param {object} ele Element
 */
export const scrollToTop = (ele) => {
  const scrollableParent = getFirstScrollableParent(ele);
  const scrollPaddingTop = getCheckoutScrollPaddingTop(ele);
  const topOffset = scrollableParent === document.documentElement ? 0 : scrollableParent.getBoundingClientRect().top;
  const scrollOffset = ele.getBoundingClientRect().top - topOffset - scrollPaddingTop;
  scrollableParent.scrollTo({
    top: scrollableParent.scrollTop + scrollOffset,
    behavior: 'smooth',
  });
};

/**
 * scroll to position element at the bottom of viewport
 * @param {object} ele Element
 */
export const scrollToBottom = (ele) => {
  const scrollableParent = getFirstScrollableParent(ele);
  let viewportBottom = window.innerHeight;

  if (scrollableParent === document.documentElement) {
    // offset of mobile view bottom (footer height + padding)
    const opcFooter = document.querySelector('#new_buyflow_footer_container');
    viewportBottom = viewportBottom - (opcFooter ? opcFooter.offsetHeight : 0) - 8;
  } else {
    // For non-document containers, use container's bottom with padding
    viewportBottom = scrollableParent.getBoundingClientRect().bottom - 8;
  }

  const eleRect = ele.getBoundingClientRect();

  // Calculate how much to scroll to bring element's bottom to viewport bottom
  const scrollOffset = eleRect.bottom - viewportBottom;

  scrollableParent.scrollTo({
    top: scrollableParent.scrollTop + scrollOffset,
    behavior: 'smooth',
  });
};
